/* Editorial layer (owner direction 2026-10-05 12:30). Two small jobs, no scroll hijacking.
   1. Ordinary navigation opens at the top of the new page. Inside a framed preview the browser can keep the previous
      page's position (reproduced on the private preview: footer "About" opened at scrollY 3087). In-page anchors,
      back/forward and reload keep their native positions, and nothing moves once the visitor has scrolled or typed.
   2. Look B reveals photo sections as they enter the viewport, with opacity and transform only (no layout shift).
      Skipped under prefers-reduced-motion; content is fully visible without this script. */
(function(){
  var d=document.documentElement;
  try{
    var nav=performance.getEntriesByType&&performance.getEntriesByType('navigation')[0];
    var native=nav&&(nav.type==='back_forward'||nav.type==='reload');
    if(!native){
      var acted=false,stop=function(){acted=true};
      ['wheel','touchstart','keydown','mousedown'].forEach(function(t){addEventListener(t,stop,{once:true,passive:true})});
      var settle=function(){
        if(acted)return;
        var id=location.hash.slice(1),el=id&&document.getElementById(decodeURIComponent(id));
        if(el){if(Math.abs(el.getBoundingClientRect().top-(parseFloat(getComputedStyle(el).scrollMarginTop)||0))>4)el.scrollIntoView({block:'start',behavior:'instant'});}
        else if(!id&&scrollY>0)scrollTo({top:0,left:0,behavior:'instant'});
      };
      settle();addEventListener('DOMContentLoaded',settle);addEventListener('load',function(){settle();requestAnimationFrame(settle);});
    }
  }catch(e){}
  if(!('IntersectionObserver' in window)||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var sel='.tw-home .fc,.tw-home .inside-grid li,.tw-home .ms-diagram,.tw-home .ms-copy,.tw-home .story,.tw-home #home-reviews,.pdp-flavor-story,.pdp-formula,.pdp-pair-card';
  var run=function(){
    var els=document.querySelectorAll(sel);if(!els.length)return;
    d.classList.add('b-motion');
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('b-in');io.unobserve(e.target);}})},{rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(el){io.observe(el)});
  };
  document.readyState==='loading'?addEventListener('DOMContentLoaded',run):run();
})();
